import './union212/style';
import FormStructure from './union212/form_structure';

export default FormStructure;